import { Image, Text, View } from "@react-pdf/renderer";
import { Trans, useTranslation } from "react-i18next";
import { COMPRESSION_PILE } from "../../../constants";
import Foot from "../../Math/Units/Imperial/Foot";
import Inch from "../../Math/Units/Imperial/Inch";
import Metre from "../../Math/Units/Metric/Metre";
import Millimetre from "../../Math/Units/Metric/Millimetre";
import { DataRow, DataRowTextValue } from "../DataRow";
import { DataTableFHWA } from "../DataTableFHWA";
import { PageWrapper, styles, tableStyles } from "../SmartTitanProjektPDF";
import { imageURI } from "../Aashto/AASHTO_Innere";

export function FHWA_Aussere({ data }) {
  const { t } = useTranslation(["translation", "fhwa"]);
  let itemIndex = 1;
  let isMetric = data.Fhwa.fhwaAll.measurementType == 0;

  return (
    <>
      <PageWrapper Deckblatt={data.Deckblatt}>
        <View>
          {/* Outer Load Carrying Capacity*/}
          <Text style={styles.section}>{t("aashto.ausser.Outer Load Carrying Capacity")}</Text>

          {/* Information */}
          <Text style={styles.sectionSubText}>{t("aashto.ausser.Information")}</Text>
          {/*
              P = p D Lreq'd (dult / F.S.) = p D Lreq'd da

              P
              Design load (kips)
              D
              Diameter of micropile drill hole through bonded length (ft)
              L
              Micropile bonded length (ft)
              dult
              Ultimate skin friction (ksf)
              F.S.
              Factor of Safety
              da
              Allowable skin friction (ksf)
              */}

          <View style={{ flexDirection: "row" }}>
            {/* P = p D Lreq'd (dult / F.S.) = p D Lreq'd da */}
            <Image
              src={{
                //https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}&space;P=p\\cdot&space;D\\cdot&space;L_{req'd}\\cdot(d_{ult}/F.S.)=p\\cdot&space;D\\cdot&space;L_{req'd}\\cdot&space;da

                uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}&space;P=p\\cdot&space;D\\cdot&space;L_{req'd}\\cdot(d_{ult}/F.S.)=p\\cdot&space;D\\cdot&space;L_{req'd}\\cdot&space;da",
                method: "GET",
                headers: {},
              }}
              style={{
                height: 9,
                width: 176,
                marginLeft: 10,
              }}
            />
          </View>

          <View style={{ flexDirection: "row" }}>
            <View style={{ width: 20 }}>
              <Image
                src={{
                  uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}P",
                  method: "GET",
                  headers: {},
                }}
                style={{
                  height: 6,
                  width: 6,
                  marginLeft: 10,
                  marginTop: 5,
                }}
              />
            </View>
            <Text style={{ marginTop: 5, marginLeft: 10, fontSize: 8 }}>
              <Trans
                i18nKey="InfoboxVar_1"
                ns="fhwa"
                values={{
                  unit: isMetric ? "kN" : "kips",
                }}
              />
            </Text>
          </View>

          <View style={{ flexDirection: "row" }}>
            <View style={{ width: 20 }}>
              <Image
                src={{
                  uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}D",
                  method: "GET",
                  headers: {},
                }}
                style={{
                  height: 6,
                  width: 7,
                  marginLeft: 10,
                  marginTop: 5,
                }}
              />
            </View>
            <Text style={{ marginTop: 5, marginLeft: 10, fontSize: 8 }}>
              <Trans
                i18nKey="InfoboxVar_2"
                ns="fhwa"
                values={{
                  unit: isMetric ? "m" : "ft",
                }}
              />
            </Text>
          </View>

          <View style={{ flexDirection: "row" }}>
            <View style={{ width: 20 }}>
              <Image
                src={{
                  uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}L",
                  method: "GET",
                  headers: {},
                }}
                style={{
                  height: 6,
                  width: 6,
                  marginLeft: 10,
                  marginTop: 5,
                }}
              />
            </View>
            <Text style={{ marginTop: 5, marginLeft: 10, fontSize: 8 }}>
              <Trans
                i18nKey="InfoboxVar_3"
                ns="fhwa"
                values={{
                  unit: isMetric ? "m" : "ft",
                }}
              />
              {/* (ft) */}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: 20 }}>
              <Image
                src={{
                  uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}d_{ult}",
                  method: "GET",
                  headers: {},
                }}
                style={{
                  height: 7,
                  width: 12,
                  marginLeft: 10,
                  marginTop: 5,
                }}
              />
            </View>
            <Text style={{ marginTop: 5, marginLeft: 10, fontSize: 8 }}>
              <Trans
                i18nKey="InfoboxVar_4"
                ns="fhwa"
                values={{
                  unit: isMetric ? "kN/m²" : "psi",
                }}
              />
              {/* (ksf) */}
            </Text>
          </View>

          <View style={{ flexDirection: "row" }}>
            <View style={{ width: 20 }}>
              <Image
                src={{
                  uri: "https://latex.codecogs.com/png.image?\\inline&space;\\dpi{110}\\bg{white}F.S.",
                  method: "GET",
                  headers: {},
                }}
                style={{
                  height: 6,
                  width: 15,
                  marginLeft: 10,
                  marginTop: 5,
                }}
              />
            </View>
            <Text style={{ marginTop: 5, marginLeft: 10, fontSize: 8 }}>
              {t("InfoboxVar_5", { ns: "fhwa" })}
            </Text>
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ width: 20 }}>
              <Image
                src={imageURI("da")}
                style={{
                  height: 6,
                  width: 9,
                  marginLeft: 10,
                  marginTop: 5,
                }}
              />
            </View>
            <Text style={{ marginTop: 5, marginLeft: 10, fontSize: 8 }}>
              <Trans
                i18nKey="InfoboxVar_6"
                ns="fhwa"
                values={{
                  unit: isMetric ? "kN/m²" : "psi",
                }}
              />

              {/* (kfs) */}
            </Text>
          </View>
          {/* Outer Load Carrying Capacity */}
          <Text style={styles.sectionSubText}>
            {t("aashto.ausser.Outer Load Carrying Capacity")}
          </Text>

          <View style={tableStyles.tableContainer}>
            {/* Total Design Load */}
            <DataRow
              item={{
                title: t("designLoad", { ns: "fhwa" }),
                bezImage: {
                  uri: "https://latex.codecogs.com/png.image?\\inline&space;\\small&space;\\dpi{110}\\bg{white}P_{d}",
                  height: 7,
                  width: 9,
                },
                value: data.Fhwa.fhwaAll.totalDesignLoad.current,
                valueScale: 2,
                itemIndex: itemIndex++,
                valueUnit: isMetric ? "kN" : "kip",
              }}
            />

            {/* Selected Load Carrying Element */}
            <DataRowTextValue
              item={{
                title: t("aashto.inner.Selected Load Carrying Element"),
                value: data.Fhwa.fhwaAll.selectedCarryingElement.name,
                itemIndex: itemIndex++,
              }}
            />
            {/* Belastungsart/-Richtung */}
            <DataRowTextValue
              item={{
                title: t("inner.loadType"),
                value: t(
                  data.Fhwa.fhwaAll.loadType === COMPRESSION_PILE
                    ? "inner.compressionPile"
                    : "inner.tensionPile"
                ),
                itemIndex: itemIndex++,
              }}
            />

            {/* Bit/Hole Size */}
            <DataRow
              item={{
                title: t("aashto.inner.Bit/Hole Size"),
                value: data.Fhwa.fhwaAll.holeSize.current,
                itemIndex: itemIndex++,
                valueScale: 2,
                valueUnit: isMetric ? <Millimetre /> : <Inch />,
              }}
            />

            {/* Pile inclination to the vertical: */}
            <DataRow
              item={{
                title: t("aashto.inner.Pile inclination to the vertical"),
                bezImage: {
                  uri: "https://latex.codecogs.com/png.image?\\inline&space;\\small&space;\\dpi{110}\\bg{white}\\beta",
                  height: 8,
                  width: 5,
                },
                value: data.Fhwa.fhwaAll.pileInclinationFromVertical,
                itemIndex: itemIndex++,
                valueScale: 2,
                valueUnit: " °",
              }}
            />
          </View>

          {/* Soil Layers */}
          <Text style={styles.sectionSubText}>{t("aashto.ausser.Soil Layers")}</Text>

          {/* Tabelle */}
          <DataTableFHWA
            data={data.Fhwa.fhwaAll}
            tableInput={data.Fhwa.fhwaAll.layersInput}
            tableCalculated={data.Fhwa.fhwaAll.layersCalculated}
          />

          {/* Determining the total length */}
          <Text style={styles.sectionSubText}>
            {t("aashto.ausser.Determining the total length")}
          </Text>

          <View style={tableStyles.tableContainer}>
            {/* Length */}
            <DataRow
              item={{
                title: t("aashto.ausser.Length"),
                value: data.Fhwa.fhwaAll.inclinedLengthTableSum.current,
                valueScale: 2,
                itemIndex: itemIndex++,
                valueUnit: isMetric ? <Metre /> : <Foot />,
              }}
            />

            {/* Extension into foundation: */}
            <DataRow
              item={{
                title: t("aashto.ausser.Extension into foundation"),
                value: data.Fhwa.fhwaAll.extensionIntoFoundation.current,
                valueScale: 2,
                itemIndex: itemIndex++,
                valueUnit: isMetric ? <Metre /> : <Foot />,
              }}
            />

            {/* Total Length: */}
            <DataRow
              item={{
                title: t("aashto.ausser.Total Length"),
                value: data.Fhwa.fhwaAll.totalLength.current,
                valueScale: 2,
                itemIndex: itemIndex++,
                valueUnit: isMetric ? <Metre /> : <Foot />,
              }}
            />
          </View>
        </View>
      </PageWrapper>
    </>
  );
}
